const isSwipeDirectionLeft = ({ touchstartX, touchendX }) => touchstartX - touchendX > 0;

export default isSwipeDirectionLeft;
